<div class="detail-page-card">
    <div class="detail-page-card-title">
        {{ "title" | t: { objectName: objectName } }}
    </div>
    <div class="detail-page-card-actions">
        @for (btn of buttonConfig; track btn) {
            <button
                class="btn btn-raised me-2"
                (click)="buttonClick(btn)"
                [disabled]="btn.isDisabled"
            >
                @if (btn.icon) {
                    <i class="{{ btn.icon }}"></i>
                }
                <span>{{ btn.text }}</span>
            </button>
        }
        @if (buttonConfig && buttonConfig.length > 0) {
            <br />
        }
        @let deletePromptTitle = "deletePromptTitle" | t;
        @let deleteConfirmation =
            "deleteConfirmation" | t: { objectName: objectName };
        <button
            class="btn btn-raised red"
            (click)="deleteClick(deletePromptTitle, deleteConfirmation)"
            [disabled]="!allowDelete"
            data-uiid="detailoptions-deletebutton"
        >
            <i class="fas fa-trash"></i>
            <span>{{ "deleteButton" | t: { moduleName: moduleName } }}</span>
        </button>
    </div>
</div>
